import FrameBack from "images/frame_back.svg?react";
import type { ReactNode } from "react";
import { Component } from "react";
import { Link } from "react-router-dom";
import { getSessionUser } from "services/users/auth";
import { getErrorComponents } from "services/util";
import { logError } from "../../services/logging";
import "./style.css";

type ErrorBoundaryProps = {
  children: ReactNode;
  fallback?: ReactNode;
  pathname?: string;
};

type ErrorBoundaryState = {
  hasError: boolean;
};

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  state = {
    hasError: false,
  };

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidUpdate(prevProps: Readonly<ErrorBoundaryProps>) {
    if (this.props.pathname !== prevProps.pathname) {
      this.setState({ hasError: false });
    }
  }

  componentDidCatch(error: Error /*, _errorInfo: ErrorInfo */) {
    this.setState({ hasError: true });

    const user = getSessionUser();

    logError("Caught error in error boundary", {
      error,
      user_id: user?.id,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        this.props.fallback || (
          <div className="error-boundary">
            <div className="container">
              <p>{getErrorComponents("Sorry, we've run into unexpected error")}</p>
              <Link to="/">
                <button className="btn">Back to Homepage</button>
              </Link>
            </div>

            <FrameBack className="frame-back" />
          </div>
        )
      );
    }

    return this.props.children;
  }
}
